import { render } from "./Preview.vue?vue&type=template&id=3201e738"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=3201e738&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__